module.exports = __webpack_public_path__ + "img/emoji-laugh-240x240.36f28a30.png";